import apiService from './apiService';

export const goalsService = {
  async getGoals(): Promise<any> {
    return apiService.get('/goals');
  },

  async createGoal(goalData: any): Promise<any> {
    return apiService.post('/goals', goalData);
  },

  async getGoalById(id: string): Promise<any> {
    return apiService.get(`/goals/${id}`);
  },

  async updateGoal(id: string, updates: any): Promise<any> {
    return apiService.put(`/goals/${id}`, updates);
  },

  async deleteGoal(id: string): Promise<void> {
    return apiService.delete(`/goals/${id}`);
  },

  async getMilestones(goalId: string): Promise<any> {
    return apiService.get(`/goals/${goalId}/milestones`);
  },

  async createMilestone(goalId: string, milestoneData: any): Promise<any> {
    return apiService.post(`/goals/${goalId}/milestones`, milestoneData);
  },

  async updateMilestone(goalId: string, milestoneId: string, updates: any): Promise<any> {
    return apiService.put(`/goals/${goalId}/milestones/${milestoneId}`, updates);
  },

  async deleteMilestone(goalId: string, milestoneId: string): Promise<void> {
    return apiService.delete(`/goals/${goalId}/milestones/${milestoneId}`);
  },

  async getResources(goalId: string): Promise<any> {
    return apiService.get(`/goals/${goalId}/resources`);
  },

  async addResource(goalId: string, resourceData: any): Promise<any> {
    return apiService.post(`/goals/${goalId}/resources`, resourceData);
  },

  async markResourceCompleted(goalId: string, resourceId: string): Promise<any> {
    return apiService.put(`/goals/${goalId}/resources/${resourceId}/complete`);
  },

  async getSuggestions(): Promise<any> {
    return apiService.get('/goals/suggestions');
  },

  // ALIGNED WITH web_old: Get resource recommendations with forceRefresh support
  // Backend endpoint: GET /goals/:goalId/resources/recommendations?forceRefresh=false
  // MIGRATED FROM web_old/src/components/growth/GoalResourcesModal.tsx::generateAIRecommendations()
  async getResourceRecommendations(goalId: string, forceRefresh: boolean = false): Promise<any> {
    return apiService.get(`/goals/${goalId}/resources/recommendations`, { params: { forceRefresh } });
  },
};
